import React from 'react'
import ModalComponent from '..'
import { PRIMARY_COLOR } from '../../../constants'
import Icon from '../../icon'
import { LoadingOval } from '../../spinner/Spinner'

export const OptionSelectModal: React.FC<{
  open: boolean
  setOpen: (cal: boolean) => void
  title?: string
  onCloseCallback?: () => void
  options: {
    title: string
    onClick: () => void
    loading?: boolean
  }[]
}> = ({ open, setOpen, title, onCloseCallback = () => {}, options = [] }) => {
  return (
    <ModalComponent
      open={open}
      setOpen={setOpen}
      onCloseCallback={() => {
        onCloseCallback()
      }}
      title={title}
      childrenClassName="md:!max-w-[420px]"
    >
      <div className="flex flex-col items-center justify-center">
        {options.map((option, idx) => {
          return (
            <button
              key={`${option.title}-idx`}
              type="button"
              className="w-full flex items-center justify-between gap-4 py-4 first:pt-0 last:pb-0 border-b last:border-b-0 border-divider-gray text-base text-black"
              onClick={() => {
                option.onClick()
              }}
            >
              {option.title}

              {option.loading ? (
                <LoadingOval color={PRIMARY_COLOR} />
              ) : (
                <Icon
                  id="left-caret-new"
                  width={24}
                  height={24}
                  className="rotate-180"
                />
              )}
            </button>
          )
        })}
      </div>
    </ModalComponent>
  )
}
